import { Env, FeatureFlagRule } from "./types";

// add new feature flags
export enum FeatureFlagName {
  MESSAGING = "MESSAGING",
  EMPLOYMENT_PERIOD_START_SETTINGS = "EMPLOYMENT_PERIOD_START_SETTINGS",
}

// EXAMPLE_SIMPLE_CHECK = "SIMPLE_CHECK",
// EXAMPLE_COMPLEX_CHECK = "COMPLEX_CHECK",
// EXAMPLE_FOR_TESTING = "FOR_TESTING",

/*
  add rules for feature flags
  - can be used with a simple boolean value
    or with any combination of userIds, authScopes, and env conditions
*/
export const FEATURE_FLAGS: Record<FeatureFlagName, FeatureFlagRule> = {
  // Enable after YLPE-9088 validates the engine cutover behavior.
  [FeatureFlagName.EMPLOYMENT_PERIOD_START_SETTINGS]: {
    excludeEnv: [Env.UAT, Env.PROD],
  },
  // [FeatureFlagName.EXAMPLE_SIMPLE_CHECK]: false,
  // [FeatureFlagName.EXAMPLE_COMPLEX_CHECK]: {
  //   excludeEnv: [Env.UAT, Env.PROD],
  //   authScopes: [ADMIN],
  //   userIds: ["user-1", "user-2"],
  // },
  // [FeatureFlagName.EXAMPLE_FOR_TESTING]: {
  //   excludeEnv: [Env.PROD],
  // },
  [FeatureFlagName.MESSAGING]: {
    excludeEnv: [Env.UAT, Env.PROD],
  },
};
